import Vue from 'vue';
// eslint-disable-next-line no-unused-vars
import Vuex, { Store, Commit } from 'vuex';
import { index as types } from 'store/action-types';
// import axios from 'common/axios-utils';
import modules from './modules';

Vue.use(Vuex);

export interface State {

  // 用户信息 相关
  userInfo: {
  }
}

const actions = {
  async getUserInfo(
    context: { commit: Commit },
  ): Promise<ApiResponse.MDPDataError> {
    const url: string = '/api/user';
    const { error, data }: ApiResponse.MDPData = await window.$request.get(url);
    if (!error) {
      context.commit(types.GET_USER_INFO, data);
    }
    return error;
  },
};

const mutations = {
  [types.GET_USER_INFO](state: State, payload: any) {
    state.userInfo = payload;
  },
};

export default new Store({
  state: {
    userInfo: {
    },
  },
  mutations,
  actions,
  modules,
});
